// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__21mi1","empty":"ModalGraph_empty__jVJP7"};